export const CHANGE_REPORTS_PARAMS = 'reports/CHANGE_REPORTS_PARAMS';
export const INIT_REPORTS_PARAMS = 'reports/INIT_REPORTS_PARAMS';
export const LOCATION_PARSED = 'reports/LOCATION_PARSED';
export const RESET_RELOAD = 'reports/RESET_RELOAD';
export const SET_REPORTS_CONFIG = 'reports/SET_REPORTS_CONFIG';
export const UPDATE_GRID_PERFORMED_ACTION =
  'reports/UPDATE_GRID_PERFORMED_ACTION';
